// src/components/MovieCard.js

import React, { useContext } from "react";
import Tooltip from "./Tooltip";
import UserHistoryContext from "../context/UserHistoryContext";
import "./MovieCard.css";

const MovieCard = ({ movie }) => {
  const { getAction } = useContext(UserHistoryContext);
  const { liked, disliked } = getAction(movie.movieid);

  return (
    <div className="movie-card">
      <div className="movie-poster">
        <img src={movie.poster_path} alt={movie.title} className="movie-image" loading="lazy" />
        {liked && (
          <span className="movie-badge liked" title="Liked">
            <i className="fa-solid fa-thumbs-up"></i>
          </span>
        )}
        {disliked && (
          <span className="movie-badge disliked" title="Disliked">
            <i className="fa-solid fa-thumbs-down"></i>
          </span>
        )}
        <Tooltip movie={movie} />
      </div>
    </div>
  );
};

export default MovieCard;
